module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text_list_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.itemData.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "down_count"
  }, [_vm._v("下载量:" + _vm._s(_vm.itemData.views_count))]), _vm._v(" "), _c('div', {
    staticClass: "down_btn",
    on: {
      "click": function($event) {
        return _vm.downloadbtn()
      }
    }
  }, [_vm._v("下载")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44df7e14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listItem/TextListItem.vue
// module id = 1221
// module chunks = 0